<template>
    <div class="sustainability-wrapper">
      <app-header></app-header>
      <div class="sustainability-content">
        <app-aside :linksArray="links"></app-aside>
        <div class="sustainability-content-main">
          <app-environment v-if="this.$route.params.page == 'environment'"></app-environment>
          <app-health-and-safety v-if="this.$route.params.page == 'health-and-safety'"></app-health-and-safety>
          <app-responsibility v-if="this.$route.params.page == 'responsibility'"></app-responsibility>
          <app-sustainability-reports v-if="this.$route.params.page == 'sustainability-reports'"></app-sustainability-reports>
        </div>
      </div>
    </div>
</template>

<script>
import Header from "./sustainability/Header";
import Aside from "./shared/Aside";
import Environment from "./sustainability/Environment";
import Responsibility from "./sustainability/Responsibility";
import HealthAndSafety from "./sustainability/HealthAndSafety";
import SustainabilityReports from "./sustainability/SustainabilityReports";
export default {
  components: {
    appHeader: Header,
    appAside: Aside,
    appEnvironment: Environment,
    appResponsibility: Responsibility,
    appHealthAndSafety: HealthAndSafety,
    appSustainabilityReports: SustainabilityReports
  },
  data() {
    return {
      links: [
        { name: "Екология", url: "/sustainability/environment" },
        { name: "Безопасни условия на труд", url: "/sustainability/health-and-safety" },
        { name: "Социална отговорност", url: "/sustainability/responsibility" },
        { name: "Доклади за устойчиво развитие", url: "/sustainability/sustainability-reports" }
      ]
    };
  },
  watch: {
    $route(to, from) {
      //      this.isPageExisting();
    }
  },
  methods: {
    isPageExisting() {
      switch (this.$route.params.page) {
        case "environment":
          break;
        default:
          this.$router.replace("../404");
      }
    }
  },
  mounted() {
    //    this.isPageExisting();
  }
};
</script>

<style scoped>
.sustainability-content {
  display: flex;
}
.sustainability-content-main {
  width: 80%;
}
@media screen {
  .sustainability-content-main {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sustainability.vue